import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Navbar from "react-bootstrap/Navbar";
import { Outlet, useLocation } from "react-router";
import { GazeTrace } from "./components/gaze-trace/gaze-trace";
import { useGazeTraceSetting } from "./hooks/useGazeTraceSetting";

export default function Layout() {
  const location = useLocation();
  const [showGazeTrace, setShowGazeTrace] = useGazeTraceSetting();
  const isMainPage = location.pathname === "/";

  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary">
        <Container>
          <Navbar.Brand href="https://us.tobiidynavox.com/pages/td-browse-request-form">
            <div>
              <img
                src="TD-Browse-Icon-RGB.svg"
                width="30"
                height="30"
                className="d-inline-block align-top"
                alt="TD Browse logo"
              />
              <span className="mx-2">TD Browse Examples</span>
            </div>
          </Navbar.Brand>
          <Form>
            <Form.Check
              type="switch"
              id="gaze-trace-toggle"
              label="Gaze trace"
              checked={showGazeTrace}
              onChange={(event) => setShowGazeTrace(event.target.checked)}
            />
          </Form>
        </Container>
      </Navbar>
      {/* This is where the page content will be rendered */}
      <Outlet />
      {showGazeTrace && <GazeTrace inverted={isMainPage} />}
    </>
  );
}
